import { withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { VatRatesContextProvider } from '@features/vatRates/contexts/vatRatesContext'

import { ProductEditorFormContextProvider } from '../../contexts/productEditorFormContext'
import { ProductEditorModal, ProductEditorModalProps } from './elements/ProductEditorModal'

export const ProductEditorWithConditionalRender = (props: ProductEditorModalProps): ReactElement => (
  <VatRatesContextProvider>
    <ProductEditorFormContextProvider product={props.product}>
      <ProductEditorModal {...props} />
    </ProductEditorFormContextProvider>
  </VatRatesContextProvider>
)

export const ProductEditor = withModalConditionalRender(ProductEditorWithConditionalRender)
